import qFetch from '@/utils/qFetch'
/**
 * 通过榜单id搜索房屋
 * @param {Array} ids 榜单id集合
 */
// eslint-disable-next-line
export function qFetchHouseIds({ ids }) {
  const url = '/bnbbingo/app/promotion/cms/getextenddata'
  const ajaxData = arguments[0]
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: ajaxData,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}
/**
 * 通过房屋id获取房屋详情
 * @param {Array} houseIdList 房屋id集合
 */
// eslint-disable-next-line
export function qFetchHouseDetail({ houseIdList,noNeedPrice,needUnactive,needNoRepositoty }) {
  const url = '/bnbbingo/app/promotion/search/searchhousebyhouseidlist'
  const ajaxData = arguments[0]
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: ajaxData,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

/**
 * 以下接口——收藏各功能全部下掉
 */
/**
 * 获取收藏和关注数
 * @param {Array} activityIdList 榜单id集合
 * @param {Number} favoriteItemType 5代表cms端
 * @param {Number} virtureType 是否返回真实收藏数（1:返回真实+系数，0:真实）
 */
// eslint-disable-next-line
export function qFetchFocus({ favoriteItemType,activityIdList,virtureType }) {
  const url = '/bnbbingo/app/promotion/favorite/searchfavoritepeoplenum'
  const ajaxData = arguments[0]
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: ajaxData,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}
/**
 * 获取收藏状态
 * @param {Array} activityIdList 榜单id集合
 */
// eslint-disable-next-line
export function qCheckFavorite({ activityIdList }) {
  const url = '/bnbbingo/app/promotion/favorite/searchcmsfavoritestatus'
  const ajaxData = arguments[0]
  return qFetch({
    url: '/tjbnb/app/common/login',
    data: ajaxData,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

export function qFetchFavorite(activityId, like) {
  let url = ''
  if (like) {
    url = '/promotion/favorite/favoritecmstujia'
  } else {
    url = '/promotion/favorite/cancelfavoritecmstujia'
  }
  const ajaxData = arguments[0]
  return qFetch({
    url: '/tjbnb/app/common/login',
    data: ajaxData,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}
